var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "217px",
    height: "237px",
    viewBox: "0 0 217 237",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mf-avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 108,
    cy: 108,
    r: 108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.19744231e-14,144 L-3.19744231e-14,-1.42108547e-14 L237.6,-1.42108547e-14 L237.6,144 L226.8,144 C226.8,203.646753 178.446753,252 118.8,252 C59.153247,252 10.8,203.646753 10.8,144 L10.8,144 L-3.19744231e-14,144 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,0 C117.835151,-5.11323436e-15 140.4,22.5648486 140.4,50.4 L140.400938,55.9494825 C145.50836,56.8068094 149.4,61.2489341 149.4,66.6 L149.4,79.2 C149.4,84.6471857 145.367296,89.1524828 140.124546,89.8932318 C138.264968,107.718065 127.114,122.779595 111.600867,130.149444 L111.6,146.7 L115.2,146.7 C150.988052,146.7 180,175.711948 180,211.5 L180,219.6 L0,219.6 L0,211.5 C-4.38277231e-15,175.711948 29.0119482,146.7 64.8,146.7 L68.4,146.7 L68.4001308,130.149918 C52.8864784,122.78024 41.7350715,107.718447 39.8746409,89.8932685 C34.6327044,89.1524828 30.6,84.6471857 30.6,79.2 L30.6,66.6 C30.6,61.2485843 34.4921486,56.8062286 39.6000641,55.9493144 L39.6,50.4 C39.6,22.5648486 62.1648486,5.11323436e-15 90,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.401336,11.7639465 C156.691257,13.5869406 169.2,18.5974066 169.2,31.5692308 L169.194195,31.1796307 C192.467264,41.0099495 208.8,64.0473854 208.8,90.8995362 L208.8,99 L28.8,99 L28.8,90.8995362 C28.8,64.0473854 45.1327357,41.0099495 68.4058046,31.1796307 C68.6525649,18.4964574 81.0734584,13.568361 97.199665,11.7638345 L97.2,28.8 C97.2,40.7293506 106.870649,50.4 118.8,50.4 C130.729351,50.4 140.4,40.7293506 140.4,28.8 L140.4,28.8 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6060596,13.6152695 C32.5581409,22.1578223 39.8033886,28.8 48.6,28.8 C57.4237849,28.8 64.6866067,22.1167224 65.6025833,13.5360492 C65.6763017,12.8454714 64.9050687,11.7 63.9384903,11.7 C50.5338783,11.7 40.2641292,11.7 33.3781419,11.7 C32.4059551,11.7 31.5108052,12.7605992 31.6060596,13.6152695 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: 0,
    width: 237.6,
    height: 252
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.134982,20.9283675 C115.651186,18.3903589 112.767321,16.2361467 109.962327,14.0758953 C109.34341,13.5996978 108.714559,13.134975 108.109489,12.6406597 C107.971919,12.528329 106.562799,11.5191649 106.394222,11.147749 C105.988434,10.2542371 106.223538,10.9499625 106.27953,9.8837271 C106.350272,8.53545721 109.099576,4.72738744 107.048059,3.85410714 C106.145572,3.47000876 104.535665,4.49215737 103.669903,4.82975328 C101.976612,5.49045082 100.262549,6.05391591 98.5120609,6.53977621 C99.3507296,4.86870665 100.949799,1.52354791 97.944319,2.41887158 C95.6029101,3.11640875 93.421047,4.90977378 91.068199,5.75346159 C91.8466618,4.47736113 94.9599107,0.523140708 92.1467884,0.302102957 C91.2713941,0.233255133 88.7240809,1.87533613 87.781557,2.22561453 C84.9585007,3.27493992 82.0749374,3.95315138 79.1109992,4.48732594 C69.0328266,6.30364025 57.2475146,5.78577175 47.9231203,10.3741169 C40.7345316,13.9113248 33.6362518,19.399825 29.4835474,26.3887851 C25.4810568,33.1253031 23.9840362,40.4977576 23.1462706,48.2171688 C22.531568,53.8823181 22.4815971,59.7383087 22.7690804,65.4239915 C22.8630017,67.2868082 23.0725183,75.8737625 25.7787751,73.2732473 C27.1270871,71.9775192 27.1171531,66.7453865 27.4567146,64.9743669 C28.1325262,61.4507473 28.7830513,57.9114256 29.9098054,54.5004387 C31.8953972,48.4895405 34.2377091,45.6866929 39.1842288,41.5467645 C42.3585867,38.890386 44.5877115,35.3000323 47.625402,32.6201006 C48.9899695,31.4164715 47.9487079,31.5417866 50.1426122,31.6997139 C51.6164535,31.8057033 53.0969174,31.8461665 54.573769,31.8848179 C57.9901549,31.9735954 61.4119592,31.950948 64.8292481,31.9630266 C71.7113886,31.9877877 78.561319,32.0850201 85.4368368,31.7247769 C88.4922881,31.5647359 91.5561682,31.4780722 94.6034916,31.1954338 C96.3058144,31.0375065 99.3263462,29.9465101 100.727639,30.7802331 C102.010026,31.5429945 103.341781,34.0335947 104.262631,35.0536296 C106.438172,37.4642093 109.032145,39.3052847 111.576147,41.2819419 C116.880892,45.4034505 119.559153,46.9800218 121.170264,53.4209169 C122.775354,59.8379568 122.325315,65.791335 124.312111,72.106311 C124.661606,73.2166332 125.586068,75.1304819 126.725767,73.4150236 C126.93739,73.0964515 126.882603,71.3451249 126.882603,70.3374051 C126.882603,66.269634 127.912727,63.2175395 127.899903,59.1232077 C127.849209,46.6744341 127.446733,30.4417478 118.134982,20.9283675 Z",
    id: "path-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mf-avatar",
    transform: "translate(-10.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(10.800000, 36.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Circle-Background",
    fill: "#07111f",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD8D-Circle-Color",
    mask: "url(#mask-2)",
    fill: "#29ABE2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 216.445361,
    height: 216
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(28.800000, 32.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0C6AC",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFB-05-Pale",
    mask: "url(#mask-6)",
    fill: "#FFDBB4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.800000, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 238.383871,
    height: 220.354839
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M39.6,84.6 C39.6,112.435151 62.1648486,135 90,135 C117.835151,135 140.4,112.435151 140.4,84.6 L140.4,84.6 L140.4,91.8 C140.4,119.635151 117.835151,142.2 90,142.2 C62.1648486,142.2 39.6,119.635151 39.6,91.8 Z",
    id: "Neck-Shadow",
    fillOpacity: 0.100000001,
    fill: "#000000",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clothing/Hoodie",
    transform: "translate(0.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Hoodie",
    fill: "#B7C1DB",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Slate",
    mask: "url(#mask-8)",
    fill: "#293347",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 238.490722,
    height: 99
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.7997922,55.5650565 L91.8,99 L85.5,99 L85.4989717,52.3346251 C87.4825877,53.5136414 89.5915786,54.5944735 91.7997922,55.5650565 Z M152.101479,52.334357 L152.1,88.65 C152.1,90.389697 150.689697,91.8 148.95,91.8 C147.210303,91.8 145.8,90.389697 145.8,88.65 L145.80121,55.5646162 C148.009227,54.594073 150.118032,53.5132992 152.101479,52.334357 Z",
    id: "Straps",
    fill: "#F4F4F4",
    fillRule: "evenodd",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.733313,11.4514328 C169.280438,14.0134155 178.65,19.1179672 178.65,29.0769231 C178.65,46.8180086 148.916087,61.2 118.8,61.2 C88.6839126,61.2 58.95,46.8180086 58.95,29.0769231 C58.95,19.1179672 68.3195623,14.0134155 81.8666868,11.4514328 C73.6891467,14.4655041 68.4,19.534193 68.4,27.9692308 C68.4,46.3220778 93.4390843,61.2 118.8,61.2 C144.160916,61.2 169.2,46.3220778 169.2,27.9692308 C169.2,19.7104496 164.129585,14.6788022 156.241116,11.6422715 Z",
    id: "Shadow",
    fillOpacity: 0.16,
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(68.400000, 73.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth/Smile",
    transform: "translate(1.800000, 46.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mouth",
    fillOpacity: 0.699999988,
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6,1.8 L58.5,1.8 C60.9852814,1.8 63,3.81471863 63,6.3 L63,11.7 C63,14.1852814 60.9852814,16.2 58.5,16.2 L39.6,16.2 C37.1147186,16.2 35.1,14.1852814 35.1,11.7 L35.1,6.3 C35.1,3.81471863 37.1147186,1.8 39.6,1.8 Z",
    id: "Teeth",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tongue",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#mask-10)",
    fill: "#FF4F6D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.200000, 21.600000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.9,
    cy: 9.9,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.9,
    cy: 9.9,
    r: 9.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Nose/Default",
    transform: "translate(25.200000, 36.000000)",
    fill: "#000000",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,7.2 C14.4,11.1764502 19.2353247,14.4 25.2,14.4 L25.2,14.4 C31.1646753,14.4 36,11.1764502 36,7.2",
    id: "Nose"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes/Happy-\\uD83D\\uDE01",
    transform: "translate(0.000000, 7.200000)",
    fill: "#000000",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5441507,20.2025804 C16.2060084,16.7836572 19.9479802,14.4 24.2978223,14.4 C28.6323089,14.4 32.3632095,16.7668578 34.0338166,20.1664118 C34.5300845,21.1762779 33.8238934,22.0027335 33.1115463,21.3903205 C30.9055557,19.493805 27.7728447,18.3094095 24.2978223,18.3094095 C20.9314855,18.3094095 17.8863826,19.4208767 15.6937852,21.2144771 C14.8921136,21.8702649 14.0580911,21.202546 14.5441507,20.2025804 Z",
    id: "Squint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7441507,20.2025804 C68.4060084,16.7836572 72.1479802,14.4 76.4978223,14.4 C80.8323089,14.4 84.5632095,16.7668578 86.2338166,20.1664118 C86.7300845,21.1762779 86.0238934,22.0027335 85.3115463,21.3903205 C83.1055557,19.493805 79.9728447,18.3094095 76.4978223,18.3094095 C73.1314855,18.3094095 70.0863826,19.4208767 67.8937852,21.2144771 C67.0921136,21.8702649 66.2580911,21.202546 66.7441507,20.2025804 Z",
    id: "Squint"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow/Natural/Default-Natural",
    fill: "#000000",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4351841,5.58911128 C18.2497998,6.28511594 10.1636382,10.8047231 10.839834,16.03603 C10.8620533,16.2072489 11.1210572,16.2606121 11.2328169,16.1176444 C13.4706637,13.2483016 30.7735176,9.03289328 37.0748406,9.91324359 C37.6515471,9.99400182 38.0322596,9.39873091 37.6389451,9.02718599 C34.2689096,5.84536884 28.0803412,4.96102342 23.4351841,5.58911128",
    id: "Eyebrow",
    transform: "translate(24.300000, 10.800000) rotate(5.000000) translate(-24.300000, -10.800000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5351841,5.58911128 C71.3497998,6.28511594 63.2636382,10.8047231 63.939834,16.03603 C63.9620533,16.2072489 64.2210572,16.2606121 64.3328169,16.1176444 C66.5706637,13.2483016 83.8735176,9.03289328 90.1748406,9.91324359 C90.7515471,9.99400182 91.1322596,9.39873091 90.7389451,9.02718599 C87.3689096,5.84536884 81.1803412,4.96102342 76.5351841,5.58911128",
    id: "Eyebrow",
    transform: "translate(77.400000, 10.800000) scale(-1, 1) rotate(5.000000) translate(-77.400000, -10.800000) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Short-Hair",
    stroke: "none",
    fill: "#1F3140",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Hair/Brown-Dark",
    stroke: "none",
    fill: "none",
    mask: "url(#mask-14)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.100000, -15.000000)",
    fill: "#4A312C",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 239.106977,
    height: 252.406452
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8f2d8fc262e21f129dd71cd7bbef562e.svg";
export { ForwardRef as ReactComponent };